import React from 'react';
import { X, Clock, Eye, ArrowRight, CheckCircle } from 'lucide-react';

interface ReviewModeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onStartReview: () => void;
  onSubmitDirectly: () => void;
  skippedOrMarkCount: number;

}

export const ReviewModeModal: React.FC<ReviewModeModalProps> = ({
  isOpen,
  onClose,
  onStartReview,
  onSubmitDirectly,
  skippedOrMarkCount

}) => {
  if (!isOpen) return null;

  

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold text-gray-800">Active Review Mode </h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="w-6 h-6 text-gray-400" />
            </button>
          </div>
        </div>

        <div className="p-4">
          <div className="mb-3">
            <div className="flex items-center gap-3 mb-2">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                <Eye className="w-6 h-6 text-blue-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800">
                  You have {skippedOrMarkCount} question{skippedOrMarkCount !== 1 ? 's' : ''} to review
                </h3>
             
              </div>
            </div>

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-3">
              <h4 className="font-semibold text-blue-900 mb-2">What is Review Mode?</h4>
              <p className="text-blue-800 text-sm leading-relaxed">
                Review Mode allows you to focus exclusively on questions you've skipped or marked for review. 
                You'll only be able to navigate through these specific questions, helping you efficiently 
                complete your remaining work before final submission.
              </p>
            </div>

            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <Clock className="w-4 h-4 text-blue-600" />
                </div>
                <div>
                  <h5 className="font-medium text-gray-800">Focused Navigation</h5>
                  <p className="text-sm text-gray-600">
                    Navigate only through skipped and marked questions - no distractions
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <CheckCircle className="w-4 h-4 text-green-600" />
                </div>
                <div>
                  <h5 className="font-medium text-gray-800">Answer & Complete</h5>
                  <p className="text-sm text-gray-600">
                    Answer remaining questions to improve your score
                  </p>
                </div>
              </div>

            
            </div>
          </div>

          <div className="border-t border-gray-200 pt-2">
            <div className="flex gap-3">
              <button
                onClick={onStartReview}
                className="flex-1 bg-blue-600 text-white py-2 px-3 rounded-lg hover:bg-blue-700 transition-colors font-medium"
              >
                Go Ahead With Review Mode
              </button>
              <button
                onClick={onSubmitDirectly}
                className="flex-1 bg-gray-100 text-gray-700 py-2 px-3 rounded-lg hover:bg-gray-200 transition-colors font-medium"
              >
                Submit Without Review
              </button>
            </div>
            <p className="text-xs text-gray-500 text-center mt-2">
              You can change your mind and submit without reviewing all questions
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};